import React from 'react';
import { motion } from 'framer-motion';
import './styles.scss';
import config from 'config';
import DeleteIcon from 'assets/icons/delete_user_icon.svg';
import EditIcon from 'assets/icons/edit_list_item_icon.svg';
import { countyEntityFilterTableItemContentMotion } from './animation';
import { ICountyEntityFilterTableItemProps } from './interface';

function CountyEntityFilterTableItem({
    item,
    onDelete,
    onEdit,
    url,
}: ICountyEntityFilterTableItemProps) {
    const currentDate = new Date();
    return (
        <motion.div
            {...countyEntityFilterTableItemContentMotion}
            className='county-entity-filter-table-item'
        >
            <div className='county-entity-filter-table-item__clicable'>
                <div className='county-entity-filter-table-item__clicable__left-field'>
                    <div className='county-entity-filter-table-item__clicable__left-field__img'>
                        <img
                            src={`${config.API_URL}${url}/images/${item.Id}?date=${currentDate}`}
                            alt='Item Img'
                        />
                    </div>
                </div>
                <div className='county-entity-filter-table-item__clicable__left-field'>
                    <p>{item.Name}</p>
                </div>
                <div className='county-entity-filter-table-item__clicable__right-field'>
                    <p>{item.Info}</p>
                    <button
                        type='button'
                        className='county-entity-filter-table-item__clicable__right-field__edit-button'
                        onClick={onEdit}
                    >
                        <img src={EditIcon} alt='Edit Icon' />
                    </button>
                    <button
                        type='button'
                        className='county-entity-filter-table-item__clicable__right-field__delete-button'
                        onClick={onDelete}
                    >
                        <img src={DeleteIcon} alt='Delete Icon' />
                    </button>
                </div>
            </div>
        </motion.div>
    );
}

export default CountyEntityFilterTableItem;
